module.exports = __webpack_public_path__ + "static/media/logo-SandMe.1c497e71.svg";